import {
  AddBankNameParams,
  AddBankNameResponse,
  GetBankListParams,
  GetBankListResponse,
} from '@nxsys/types/api/bank';
import axios from '../axios';
import { endPoints } from '../endpoints';

const url = import.meta.env.VITE_URL_VERIFY_BANK ?? '';
const Key = import.meta.env.VITE_VERIFY_BANK_API_KEY ?? '';

export const verifyBankAccount = ({ params, cb }: any) => {
  const { AccountNumbers, SortCodes } = params;
  let query = '';
  query += '&Key=' + encodeURIComponent(Key);
  query += '&AccountNumbers=' + encodeURIComponent(AccountNumbers);
  query += '&SortCodes=' + encodeURIComponent(SortCodes);
  const http = new XMLHttpRequest();
  http.open('POST', url, true);
  http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  http.onreadystatechange = function () {
    if (http.readyState === 4 && http.status === 200) {
      const response = JSON.parse(http.responseText);
      // Test for an error
      const { Items } = response;
      cb(Items[0]);
      // if (response.Items.length === 1 && typeof(response.Items[0].Error) !== "undefined") {
      //   // Show the error message
      //   // alert(response.Items[0].Description);
      //   cb({ error: response.Items[0].Description });
      // } else {
      //   // Check if there were any items found
      //   if (response.Items.length === 0)
      //       alert("Sorry, there were no results");
      //   else {
      //     const { Items } = response;
      //     cb(Items[0]);
      //   }
      // }
    }
    cb();
  };
  http.send(query);
};

export const getBankListApi = async (
  params?: GetBankListParams,
): Promise<GetBankListResponse> => {
  const response = await axios.get(`${endPoints.getBankList}`, { params });
  return response.data;
};

export const addBankNameApi = async (
  params: AddBankNameParams,
): Promise<AddBankNameResponse> => {
  const response = await axios.post(`${endPoints.getBankList}`, params);
  return response.data;
};

export default {
  verifyBankAccount,
};
